// ✅ Si la imagen está dentro de /src (ej: src/assets/images/...)
import bannerImage from "../assets/images/work-with-us.jpg";

// Banner Component
const Banner = () => {
  return (
    <div
      className="relative w-full h-[400px] flex items-center justify-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `url(${bannerImage})`,
        marginTop: "100px",
      }}
    >
      {/* Overlay con opacidad correcta en Tailwind v3 */}
      <div className="absolute inset-0 bg-black/40"></div>

      {/* Texto centrado */}
      <h2 className="relative z-10 text-white text-4xl md:text-5xl font-bold drop-shadow-lg text-center">
        Trabaja con nosotros
      </h2>
    </div>
  );
};

export default Banner;